import { CommonPropsType } from './common';

export enum TransactionType {
  Topup = 1,
  Withdrawal
}

export type TransactionListItemType = {
  button_type: string;
  button_id: string;
  sn: string;
  amount: string;
  bank_name: string;
  payment_channel_text: string;
  create_time: string;
  status: number;
};

export type TransactionItemType = {
  button_type: string;
  button_id: string;
  sn: string;
  amount: string;
  bank_name: string;
  payment_channel_text: string;
  create_time: string;
  status: number;
};

export type ChatBtnType = {
  text_key: string;
  text_value: string;
  uri_key: string;
  queue_name?: string;
  user_type_id: number;
  enquiry_type_id: number;
  button_type?: string;
  button_id?: string;
  extra_param?: string;
  node_id?: string;
};

export interface ApiGetTransactionsLoadMoreDataReplyType {
  reply_type: number;
  message: {
    message_id: string;
    text_key: string;
    text_value: string;
    text_extra: null;
  };
  message_extra: {
    transaction: {
      node_id: string;
      has_more: boolean;
      type: TransactionType; // 交易类型：1充值 2提现
      list: TransactionListItemType[];
    };
    buttons_for_live: ChatBtnType[];
  };
}

export interface StateTransactionListPropsType extends CommonPropsType {
  nodePointId: string;
  moreButtonType: string;
  moreButtonId: string;
  id: string;
  msgContent: string;
  node_id: string;
  has_more: boolean;
  type: TransactionType;
  list: TransactionListItemType[];
  buttons_chat_main_location: ChatBtnType & { message: string };
  buttons_chat_vice_location: ChatBtnType & { message: string };
}

export interface StateTransactionListResponseHandlerType {
  dialogueId: string;
  dialogueType: string;
  from: 'bot' | 'user';
  type: 'StateTransactionList';
  data: StateTransactionListPropsType;
}

